<!-- Zweck: Stellt die HTML-Struktur für app login component im Frontend bereit. -->
<div class="logincontentinner">
  <div>
    <div class="loginlogobox">
      <img class="logo" src="{{domaincfg.logofilename}}" alt="Login Logo"/>
    </div>


    <div class="loginbox">
      <div class="bar">Login {{ domaincfg.pagetitle }}</div>


      @if (domaincfg.login_welcome_message) {
        <div class="welcometext">{{ domaincfg.login_welcome_message }}</div>
      }

      <mat-form-field [ngClass]="{ 'has-error': (!errorUsername.loading && errorUsername.isError) }" appearance="fill">
        <mat-label>Benutzername</mat-label>
        <input [(ngModel)]="model.username" [errorStateMatcher]="errorUsername" type="email" email
               required matInput name="username" (input)="validate()" (keydown)="validate()" (change)="validate()" (keydown.enter)="login()">
        @if (!errorUsername.loading && !errorUsername.isError && model.username) {
          <span matSuffix>
            <svg-icon matTooltip="OK" style="color: green">check</svg-icon>
          </span>
        }
        @if (!errorUsername.loading && errorUsername.isError) {
          <span matSuffix>
            <svg-icon matTooltip="{{errorUsername.error_text}}" style="color: red">error</svg-icon>
          </span>
        }
        @if (errorUsername.error_text) {
          <mat-error>
            <svg-icon>error</svg-icon>
            {{ errorUsername.error_text }}
          </mat-error>
        }
      </mat-form-field>

      <div style="height: 100px; margin-top: 20px">

        <mat-form-field [ngClass]="{ 'has-error': (!errorPassword.loading && errorPassword.isError) }"
                        appearance="fill">
          <mat-label>Passwort</mat-label>
          <input [(ngModel)]="model.password" [errorStateMatcher]="errorPassword" matInput
                 minlength="8"
                 name="password"
                 required type="password" (input)="validate()" (keydown)="validate()" (change)="validate()" (keydown.enter)="login()">
          @if (!errorPassword.loading && !errorPassword.isError && model.password) {
            <span matSuffix>
              <svg-icon matTooltip="OK" style="color: green">check</svg-icon>
            </span>
          }
          @if (!errorPassword.loading && errorPassword.isError) {
            <span matSuffix>
              <svg-icon matTooltip="{{errorPassword.error_text}}" style="color: red">error</svg-icon>
            </span>
          }
          @if (errorPassword.error_text) {
            <mat-error>
              <div style="white-space: normal; max-width: 200px">
                <svg-icon>error</svg-icon>
                {{ errorPassword.error_text }}
              </div>
            </mat-error>
          }
        </mat-form-field>

        @if (loginError|async) {
          <div
            class="help-block" style="color: red">{{ loginError|async }}
          </div>
        }

      </div>


      <div class="form-group" [style.margin-top]="errorPassword.error_text ? '30px' : null">
        <button [disabled]="(loading|async) || !(valid|async)" class="btn btn-primary" mat-flat-button (click)="login()">
          <svg-icon>login</svg-icon>
          Anmelden
        </button>
        <div style="height: 22px; margin-top: 10px; margin-bottom: 20px">
          <img [class.hidden]="!(loading|async)"
               src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="/>
        </div>

        <a routerLink="/reset-password">
          Passwort zurücksetzen
        </a>
      </div>

      <div style="text-align: center">
        <hr style="max-width: 200px">
      </div>

      <div>
        <button mat-raised-button routerLink="/register">
          <svg-icon>registrieren</svg-icon>
          Registrieren
        </button>
      </div>
    </div>
  </div>
</div>
